import { Component } from '@angular/core';
import { CompanyMasterProperties } from '../Models/CompanyMasterProperties';
import { NgForm } from '@angular/forms';
import { companyMasterService } from '../Services/companyMaster.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
declare var $;
@Component({
    selector: 'app-company-master',
    templateUrl: './companyMaster.component.html',
    styleUrls: ['./companyMaster.component.css']
})

export class CompanyMasterComponent {
    companyMaster = new CompanyMasterProperties();
    companyMasterList: CompanyMasterProperties[] = [];
    companyMasterSubmitted: boolean = false;
    collapsed: boolean = false;
    constructor(private companyMasterService: companyMasterService, private companyModal: NgbModal) {

    }
    ngOnInit() {
        this.GetCompanyMaster();
    }
    contentReady = (e) => {
        $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold" });
        if (!this.collapsed) {
            this.collapsed = true;
            e.component.expandRow(["EnviroCare"]);
        }
    };
    OpenModel(targetModel){
        this.companyModal.open(targetModel, {
            centered: true,
            backdrop: 'static',
            keyboard: false,
            size: 'md'
        })
    }
    AddComapnyMaster(targetModel) {
      
       this.OpenModel(targetModel);

    }
    ChangeStatus(event) {

        if (event.target.checked == true) {
            this.companyMaster.companyStatus = true;
        }
        else {
            this.companyMaster.companyStatus = false;
        }
    }
    SaveCompanyMaster(companyMasterForm) {
        this.companyMasterSubmitted = true;
        if (companyMasterForm.invalid) {
            return;
        }
        else {
            if(this.companyMaster.companyId==0){
                this.CreateCompanyMaster();
            }
            else{
                this.UpdateCompanyMaster();
            }
           
        }

    }
    CreateCompanyMaster(){
        document.getElementById("companyMaster_submit").setAttribute('disabled', 'disabled');
        this.companyMasterService.AddCompanyMaster(this.companyMaster).subscribe(data => {
            if (data == true) {

                document.getElementById("companyMaster_submit").removeAttribute('disabled');
                document.getElementById("companyMasterSuccess").innerHTML = "Company Created Successfully";
                setTimeout(() => {
                    document.getElementById("companyMasterSuccess").innerHTML = "";
                    this.GetCompanyMaster();
                    this.companyModal.dismissAll();

                }, 500)
                this.companyMaster = new CompanyMasterProperties();
                this.companyMasterSubmitted = false;
            }
            else {
                document.getElementById("companyMaster_submit").removeAttribute('disabled');
                document.getElementById("companyMasterError").innerHTML = "**Something Went Wrong!";
                setTimeout(() => {
                    document.getElementById("companyMasterError").innerHTML = "";
                }, 5000)
            }

        })

    }
    UpdateCompanyMaster(){
        document.getElementById("companyMaster_submit").setAttribute('disabled', 'disabled');
       
        this.companyMasterService.UpdateCompanyMaster(this.companyMaster).subscribe(data => {
            if (data == true) {

                document.getElementById("companyMaster_submit").removeAttribute('disabled');
                document.getElementById("companyMasterSuccess").innerHTML = "Company Updated Successfully";
                setTimeout(() => {
                    document.getElementById("companyMasterSuccess").innerHTML = "";
                    this.GetCompanyMaster();
                    this.companyModal.dismissAll();

                }, 500)
                this.companyMaster = new CompanyMasterProperties();
                this.companyMasterSubmitted = false;
            }
            else {
                document.getElementById("companyMaster_submit").removeAttribute('disabled');
                document.getElementById("companyMasterError").innerHTML = "**Something Went Wrong!";
                setTimeout(() => {
                    document.getElementById("companyMasterError").innerHTML = "";
                }, 5000)
            }

        })

    }
    GetCompanyMaster() {
        this.companyMasterService.GetCompanyMaster().subscribe(data => {
            this.companyMasterList = data;

        })
    }
    Edit_CompanyMaster(companyId,targetModel){
        this.companyMasterService.GetCompanyMasterById(companyId).subscribe(data => {
            this.companyMaster = data;
            this.OpenModel(targetModel);

        })
       

    }
    CloseComapnyMasterModal() {
        this.companyMaster = new CompanyMasterProperties();
        this.companyModal.dismissAll();

    }
}